export const en = {
  couldYouTakeAMoment: 'Could you take a moment to update your details? ',
  updateYourDetails: 'Update your details',
  weMadeChanges: 'We’ve made some changes since you last used BugHerd to improve security & usability.',
  waitWhats: 'Wait, what’s ',
  bugherd: 'BugHerd',
  };
  
  export type Translations = typeof en;
  